import { axiosClient } from "services/axios";

import {
  AddEmployeesGroupParams,
  EditEmployeesGroupParams,
  AssignAccessParams,
} from "../types";

export function assignAccess(params: AssignAccessParams) {
  return axiosClient.post("users/assign-access", params);
}

export function deleteAccess(access_id: string) {
  return axiosClient.post("users/delete-access", { access_id });
}

export function addEmployeesGroup(params: AddEmployeesGroupParams) {
  return axiosClient.post("users/user-group", params);
}

export function editEmployeesGroup(params: EditEmployeesGroupParams) {
  return axiosClient.put("users/user-group", params);
}

export function getEmployeesAccess(
  { forOffice }: { forOffice: boolean } = { forOffice: true }
) {
  return axiosClient
    .get(`users/access?forOffice=${forOffice}`)
    .then((res) => res.data);
}
